import { DataHelper } from 'tiime-expert-utils';

import { ArithmeticHelper } from '@helpers/arithmetic.helper';
import { HttpHelper } from '@helpers/http.helper';
import { PcgEntry, PcgEntryJson } from '@models/pcg-entry';

export interface AccountInterestLineJson {
  id: number;
  pcg_entry: Partial<PcgEntryJson>;
  amount: number;
  rate: number | null;
  interest_amount: number | null;
  deductible_interest_amount: number | null;
  non_deductible_interest_amount: number | null;
  accountable: boolean;
}

export class AccountInterestLine {
  constructor(
    public id: number,
    public pcgEntry: PcgEntry,
    public amount: number,
    public rate: number | null,
    public interestAmount: number | null,
    public deductibleInterestAmount: number | null,
    public nonDeductibleInterestAmount: number | null,
    public accountable: boolean
  ) {}

  static fromJson(json: AccountInterestLineJson): AccountInterestLine {
    return new AccountInterestLine(
      json.id,
      PcgEntry.fromJson(json.pcg_entry),
      json.amount,
      !DataHelper.isNullish(json.rate) ? ArithmeticHelper.mul(json.rate, 100) : null,
      json.interest_amount,
      json.deductible_interest_amount,
      json.non_deductible_interest_amount,
      json.accountable
    );
  }

  static toJson(data: AccountInterestLine): AccountInterestLineJson {
    return {
      id: data.id,
      pcg_entry: HttpHelper.toJsonId(data.pcgEntry),
      amount: data.amount,
      rate: !DataHelper.isNullish(data.rate)
        ? ArithmeticHelper.div(ArithmeticHelper.toFloat(data.rate), ArithmeticHelper.toFloat(100), 4)
        : null,
      interest_amount: data.interestAmount,
      deductible_interest_amount: data.deductibleInterestAmount,
      non_deductible_interest_amount: data.nonDeductibleInterestAmount,
      accountable: data.accountable
    };
  }
}
